import * as _4 from 'lodash4';

import { StudyGroupMembersQuery } from '../queries/study_group_members_query';
import { ICourseSection, IStudyGroupMember } from '../study_group_interfaces';

export class StudyGroupsEmailServant {
  constructor(private ngStudyGroupMembersQuery: StudyGroupMembersQuery) {}

  getBuddiesToEmail(buddies: IStudyGroupMember[]) {
    return _4.join(
      _4.map(
        _4.filter(buddies, (buddy: any) => buddy._isChecked),
        (buddy: any) => buddy.email
      ),
      ','
    );
  }

  getEmailSubject(section: ICourseSection) {
    return `Study Buddies: ${section.courseTitle}-${section.cd} Study Buddies`;
  }

  getEmailBody(section: ICourseSection) {
    return `Hey! Would you be interested in studying together for ${section.courseTitle}-${section.cd}?`;
  }

  getEmailData(section: ICourseSection) {
    const mailTo = this.getBuddiesToEmail(this.ngStudyGroupMembersQuery.result.buddies);
    const subject = this.getEmailSubject(section);
    const body = this.getEmailBody(section);
    return { mailTo, subject, body };
  }
}

angular.module('capability-ng-study-groups').service('ngStudyGroupsEmailServant', StudyGroupsEmailServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/servants/study_groups_email_servant.ts